import { render } from "./AppClientTicketViewer.vue?vue&type=template&id=770517af&scoped=true"
import script from "./AppClientTicketViewer.vue?vue&type=script&lang=js"
export * from "./AppClientTicketViewer.vue?vue&type=script&lang=js"

import "./AppClientTicketViewer.vue?vue&type=style&index=0&id=770517af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770517af"]])

export default __exports__